import { createFileRoute } from "@tanstack/react-router";
import { DescriptionsPage } from "../../features/ai/descriptions-page";

export const Route = createFileRoute("/restaurants/$restaurantId_/descriptions")({
	component: Page,
});

function Page() {
	const { restaurantId } = Route.useParams();
	return <DescriptionsPage key={restaurantId} restaurantId={restaurantId} />;
}
